import React, {
  createContext, useCallback, useContext, useState,
} from 'react'

export const GenericStorageContext = createContext(null)

export const useGenericStorage = () => useContext(GenericStorageContext)

export const GenericStorageProvider = ({ children }) => {
  const [genericStorage, setGenericStorage] = useState({})
  const mergeIntoGenericStorage = useCallback((patch) => setGenericStorage((s) => ({ ...s, ...patch })), [])

  return (
    <GenericStorageContext.Provider
      value={{ genericStorage, mergeIntoGenericStorage }}
    >
      {children}
    </GenericStorageContext.Provider>
  )
}
